import { clsx } from "clsx";

function Scissors({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 64 40" className={className} aria-hidden>
      <g fill="none" stroke="currentColor" strokeWidth="5" strokeLinecap="round">
        <circle cx="11" cy="11" r="7.5" />
        <circle cx="11" cy="29" r="7.5" />
        <path d="M18 25 60 6M18 15l25 11" />
      </g>
    </svg>
  );
}

export function BarberPole({ className }: { className?: string }) {
  return (
    <svg viewBox="0 0 12 40" className={className} aria-hidden>
      <defs>
        <pattern id="pole" width="12" height="9" patternUnits="userSpaceOnUse" patternTransform="skewY(-35)">
          <rect width="12" height="3" fill="#9A3324" />
          <rect y="3" width="12" height="1.5" fill="#fff" />
          <rect y="4.5" width="12" height="3" fill="#4A8FD6" />
          <rect y="7.5" width="12" height="1.5" fill="#fff" />
        </pattern>
      </defs>
      <rect x="2" y="0" width="8" height="4" rx="2" fill="#4A8FD6" />
      <rect x="3" y="4" width="6" height="32" fill="url(#pole)" stroke="#e7e0d9" strokeWidth="0.5" />
      <rect x="2" y="36" width="8" height="4" rx="2" fill="#4A8FD6" />
    </svg>
  );
}

/** Recreation of the salon's logo; swap for the original artwork once the owner shares it. */
export function Logo({ size = "md", className }: { size?: "sm" | "md" | "lg"; className?: string }) {
  const scale = { sm: "text-[1.9rem]", md: "text-[2.4rem]", lg: "text-[4.5rem] sm:text-[6rem]" }[size];
  return (
    <span className={clsx("inline-flex items-center gap-2 leading-none", className)} aria-label="Style & Curl">
      <span className={clsx("font-script text-rust", scale)} style={{ lineHeight: 1 }}>
        Style <span className="text-[0.7em]">&amp;</span> Curl
      </span>
      {size !== "sm" && <Scissors className="mt-2 h-[0.9em] w-auto text-steel" />}
    </span>
  );
}

export function LogoLockup({ className }: { className?: string }) {
  return (
    <div className={clsx("inline-flex flex-col items-center", className)}>
      <div className="flex items-start gap-3">
        <span className="font-script text-[4.5rem] leading-[0.95] text-rust sm:text-[6.5rem]">
          Style
          <br />
          <span className="pl-10">Curl</span>
        </span>
        <span className="eyebrow mt-6 text-center text-steel sm:mt-10">
          Est.
          <br />
          1975
        </span>
      </div>
      <div className="mt-3 flex items-center gap-3 text-steel">
        <span className="eyebrow">Salon</span>
        <BarberPole className="h-7 w-auto" />
        <span className="eyebrow">Barber</span>
      </div>
    </div>
  );
}
